import { createSelector } from "reselect";
export const selectNewRequest = (state) => state.newReuqest;

export const selectNewRequestData = createSelector(
  selectNewRequest,
  (newReq) => newReq
);

export const selectNewRequestSourceLocation = createSelector(
  selectNewRequest,
  (newReq) => (newReq.source_location ? newReq.source_location : "")
);
export const selectNewRequestDestLocation = createSelector(
  selectNewRequest,
  (newReq) => (newReq.destination_location ? newReq.destination_location : "")
);

export const selectNewRequestOtherDestinationsLocation = createSelector(
  selectNewRequest,
  (newReq) =>
    newReq.other_destination_location ? newReq.other_destination_location : ""
);

export const selectNewRequestCities = createSelector(
  selectNewRequest,
  (newReq) => {
    return newReq.cities;
  }
);

export const selectNewRequestSelectionLevel = createSelector(
  selectNewRequest,
  (newReq) => newReq.selection_level
);
export const selectNewRequestSelectedProvince = createSelector(
  selectNewRequest,
  (newReq) => newReq.selected_province
);
export const selectNewRequestSelectedCity = createSelector(
  selectNewRequest,
  (newReq) => newReq.selected_city
);

export const selectNewRequestSelectedDistrict = createSelector(
  selectNewRequest,
  (newReq) => newReq.selected_district
);

export const selectNewRequestVehicles = createSelector(
  selectNewRequest,
  (newReq) => newReq.vehicles
);

export const selectNewRequestSelectedVehicle = createSelector(
  selectNewRequest,
  (newReq) => (newReq.selected_vehicle ? newReq.selected_vehicle : "")
);

export const selectNewRequestShownSuggestionPrice = createSelector(
  selectNewRequest,
  (newReq) => newReq.shownSuggestionPrice
);
export const selectNewRequestSuggestionPrice = createSelector(
  selectNewRequest,
  (newReq) => newReq.suggestionPrice
);

export const selectNewRequestSuggestionPriceIsLoading = createSelector(
  selectNewRequest,
  (newReq) => newReq.suggestionPrice_isLoading
);

export const selectNewRequestLoadTypes = createSelector(
  selectNewRequest,
  (newReq) => newReq.loadTypes
);

export const selectNewRequestBimeh = createSelector(
  selectNewRequest,
  (newReq) => newReq.bimeh
);

export const selectNewRequestBarnameh = createSelector(
  selectNewRequest,
  (newReq) => newReq.barnameh
);

export const selectNewRequestLoadValue = createSelector(
  selectNewRequest,
  (newReq) => newReq.load_value
);

export const selectNewRequestDescTakhlieh = createSelector(
  selectNewRequest,
  (newReq) => newReq.desc_takhlieh
);

export const selectNewRequestDescBargiry = createSelector(
  selectNewRequest,
  (newReq) => newReq.desc_bargiry
);
export const selectNewRequestLoadWeight = createSelector(
  selectNewRequest,
  (newReq) => newReq.weight
);

export const selectNewRequestSizes_length = createSelector(
  selectNewRequest,
  (newReq) => newReq.sizes_length
);
export const selectNewRequestSizes_width = createSelector(
  selectNewRequest,
  (newReq) => newReq.sizes_width
);
export const selectNewRequestSizes_height = createSelector(
  selectNewRequest,
  (newReq) => newReq.sizes_height
);

export const selectNewRequestCalenderBargiry_show = createSelector(
  selectNewRequest,
  (newReq) => newReq.calenderBargiry_show
);
export const selectNewRequestCalenderTakhlieh_show = createSelector(
  selectNewRequest,
  (newReq) => newReq.calenderTakhlieh_show
);

export const selectNewRequestDaysAhead = createSelector(
  selectNewRequest,
  (newReq) => newReq.days_ahead
);

export const selectNewRequestBargiryDate = createSelector(
  selectNewRequest,
  (newReq) => newReq.bargiry_date
);
export const selectNewRequestBargiryTime = createSelector(
  selectNewRequest,
  (newReq) => newReq.bargiry_time
);
export const selectNewRequestTakhliehDate = createSelector(
  selectNewRequest,
  (newReq) => newReq.takhlieh_date
);
export const selectNewRequestTakhliehTime = createSelector(
  selectNewRequest,
  (newReq) => newReq.takhlieh_time
);
export const selectNewRequestTakhliehTimeTo = createSelector(
  selectNewRequest,
  (newReq) => newReq.takhlieh_timeTo
);
export const selectNewRequestTakhliehTimeShow = createSelector(
  selectNewRequest,
  (newReq) => newReq.takhlieh_time_show
);

export const selectNewRequestAuctionList = createSelector(
  selectNewRequest,
  (newReq) => newReq.auctionList
);

export const selectNewRequestLoadDescLoad = createSelector(
  selectNewRequest,
  (newReq) => newReq.desc_load
);
export const selectNewRequestSelectedAuction = createSelector(
  selectNewRequest,
  (newReq) => newReq.selected_auction
);
export const selectNewRequestSelectedLoadType = createSelector(
  selectNewRequest,
  (newReq) => newReq.selected_loadType
);
export const selectNewRequestType = createSelector(
  selectNewRequest,
  (newReq) => newReq.request_type
);
export const selectNewRequestPreReqTimeShow = createSelector(
  selectNewRequest,
  (newReq) => newReq.preReq_time_show
);

export const selectNewRequestIsTwoWay = createSelector(
  selectNewRequest,
  (newReq) => newReq.is_two_way
);
export const selectNewRequestPaymentInDestination = createSelector(
  selectNewRequest,
  (newReq) => newReq.payment_in_destination
);
export const selectVehicleType = createSelector(
  selectNewRequest,
  (newReq) => newReq.vehicle_type
);
export const selectVehicleRequestedType = createSelector(
  selectNewRequest,
  (newReq) => newReq.vehicle_requested_type
);
export const selectReceiverInfo = createSelector(
  selectNewRequest,
  (newReq) => newReq.receiver_info
);
export const selectLoadingDescription = createSelector(
  selectNewRequest,
  (newReq) => newReq.loading_description
);
export const selectEvacuationDescription = createSelector(
  selectNewRequest,
  (newReq) => newReq.evacuation_description
);
export const selectPackagingType = createSelector(
  selectNewRequest,
  (newReq) => newReq.packaging_type
);
export const selectPostalCode = createSelector(
  selectNewRequest,
  (newReq) => newReq.postal_code
);
export const selectAlertNotifShow = createSelector(
  selectNewRequest,
  (newReq) => newReq.alert_notif_show
);
